module.exports = __webpack_public_path__ + "img/beauty-pass-logo.6ee1332.png";